import { useContext } from 'react';
import usefulContext from '@contexts/UsefulContext';

function useUseful() {
  return useContext(usefulContext);
}

export default useUseful;
